import { GridColDef } from "@mui/x-data-grid";
import { NameCell } from "./NameCell";
import { RoleCell } from "./RoleCell";
import { ManagePermissionsCell } from "./ManagePermissionsCell";
import { SpaceAccess } from "../types";

export type SpaceAccessRow = SpaceAccess;

export type SpaceAccessColumnsOptions = {
  onManageAccess: (space: SpaceAccess) => void;
};

export function getSpaceAccessColumns({
  onManageAccess,
}: SpaceAccessColumnsOptions): GridColDef<SpaceAccessRow>[] {
  return [
    {
      field: "name",
      headerName: "Space name",
      flex: 1,
      minWidth: 250,
      sortable: true,
      renderCell: (params) => (
        <NameCell
          primary={params.row.name}
          secondary={params.row.description}
        />
      ),
    },
    {
      field: "roles",
      headerName: "Space roles",
      minWidth: 250,
      sortable: false,
      renderCell: (params) => (
        <RoleCell roles={params.row.roles} align={"left"} />
      ),
    },
    {
      field: "management",
      headerName: "",
      minWidth: 160,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <ManagePermissionsCell
          space={params.row}
          onManageAccess={onManageAccess}
        />
      ),
    },
  ];
}
